<template>
  <div style="height: 100%">
    <component :is="$route.meta.layout || layout">
      <router-view />
    </component>

    <!-- Notification Modal for free_text messages -->
    <NotificationModal />
  </div>
</template>

<script>
import NotificationModal from "@/components/global/NotificationModal.vue";

export default {
  name: "App",
  components: {
    NotificationModal
  },
  data() {
    return {
      layout: this.$system_config.layoutDefault
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initializePushNotifications();
    });
  },
  methods: {
    async initializePushNotifications() {
      try {
        const { initPushListener } = await import("@/api/PushNotifications.js");
        initPushListener(data => {
          console.log("Notification clicked:", data);
          if (data?.url) {
            this.$router.push(data.url);
          }
        });
      } catch (e) {
        console.log("Push notifications not available:", e);
      }
    }
  }
};
</script>
<style lang="scss">
@import "@/assets/style/css/App.scss";
</style>
    }
  }
};
</script>
<style lang="scss">
@import "@/assets/style/css/App.scss";
</style>
